// import type — лише тип: імпорт стирається при компіляції,
// тож циклу модулів @utils <-> @pressure-core у рантаймі немає
import type { PressureTableSelectedFiltersMap } from "@pressure-core";

/**
 * Перейменування UI-полів колонок у ключі, які очікує бекенд
 * (ключі, які очікує бекенд у параметрі filter: manufacturers, type).
 * Напр.: { mfDev: "manufacturers", devType: "type" }.
 */
export type TableFilterFieldNameMap = Record<string, string>;

/**
 * Серіалізує вибрані фільтри колонок в об'єкт, конвертований у рядок:
 * {"manufacturers":["Radmirtech","Slot"],"gasOperators":["dnipro"],"type":["tkb"]}.
 * Формат — робоча домовленість із бекендом, ізольована у цій функції:
 * зміниться формат — правиться лише вона.
 * Ключі сортуються, щоб однаковий вибір завжди давав однаковий рядок
 * (потрібно для distinctUntilChanged в ефектах).
 * Порожній вибір -> порожній рядок (параметр filter не додається до запиту).
 */
export const serializeTableFilters = (
  filters: PressureTableSelectedFiltersMap,
  fieldNameMap: TableFilterFieldNameMap = {},
): string => {
  if (!filters) {
    return "";
  }

  const payload: Record<string, (string | number)[]> = Object.keys(filters)
    .filter((field: string) => filters[field]?.length > 0)
    .sort()
    .reduce((acc: Record<string, (string | number)[]>, field: string) => {
      acc[fieldNameMap[field] ?? field] = filters[field];
      return acc;
    }, {});

  return Object.keys(payload).length ? JSON.stringify(payload) : "";
};
